import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Home from '@/components/common/Home'
import ModelTotal from '@/components/views/ModelTotal'
import Test from '@/components/views/Test'
import DateTotal from '@/components/views/DateTotal'
import Personnel from '@/components/views/Personnel'
import Trend from '@/components/views/Trend'
import Register from '@/components/views/Register'
import WxLogin from '@/components/WxLogin'

Vue.use(Router)

const router =  new Router({
  //nginx 配置
  // base: '/finger/',
  // mode: 'history',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },{
      path: '/',
      name: 'Login',
      component: Login
    },{
      path: '/WxLogin',
      name: 'WxLogin',
      component: WxLogin
    },{
      path: '/Register',
      name: 'Register',
      component: Register
    },{
      path: '/Home',
      name: 'Home',
      component: Home,
      children: [
        { path: '/ModelTotal', component: ModelTotal },
        { path: '/Test', component: Test },
        { path: '/DateTotal', component: DateTotal },
        { path: '/Personnel', component: Personnel },
        { path: '/Trend', component: Trend }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path === '/'){
    next()
  }else{
    let time = sessionStorage.getItem('time'); //获取本地存储的登陆信息
    if (!time) {
      next('/')
    } else {
      if(to.path === '/'){
        next()
      }
      let time2 = parseInt(new Date().getTime() / 1000)
      if(time2-time>1200){
        localStorage.removeItem("time");
        next('/')
      }else{
        sessionStorage.setItem("time",time2)
        next()
      }
      
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js